import React from "react";
import {useDispatch} from "react-redux";
import humanizeString from "string-humanize";
import Toggle from "react-toggle";
import {CardBody, CardText, CardTitle} from "reactstrap";
import {acknowledgeOnOff} from "../../../../redux/Actions/controllers.actions";

const SummaryCard = ({data, headers}) => {
  const dispatch = useDispatch();

  return (
    <CardBody>
      {headers?.map((eachTitle, titleIndex) => {
        return (
          <CardTitle
            tag="h4"
            key={titleIndex}
            style={{
              marginBottom: "0px",
            }}
          >
            {humanizeString(eachTitle)}
            {": "}
            {typeof data[eachTitle] === "boolean" ? (
              <CardText
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className="power-toggle-container"
              >
                <Toggle
                  checked={data[eachTitle]}
                  onChange={() => {
                    dispatch(acknowledgeOnOff(data.id));
                  }}
                />
              </CardText>
            ) : (
              <CardText
                className={`${
                  eachTitle === "value"
                    ? data[eachTitle] === "AT LIMIT" || data["in_alarm"]
                      ? "text-danger"
                      : "text-success"
                    : ""
                }`}
              >
                {data[eachTitle]}
              </CardText>
            )}
          </CardTitle>
        );
      })}
    </CardBody>
  );
};

export default SummaryCard;
